import React, { useState, useEffect } from "react";
/** Styles Import */
import "./Style.css";
/** Components Import */
import { Modal } from "react-bootstrap";

function Dialog({
  /** Modal */
  dialogClassName = "",
  contentClassName = "",
  size = "lg",
  show = false,
  onHide = () => {},
  onClose = () => {},
  fullScreen = false,
  centered = true,
  backdrop = true, // 'static', 'true', 'false'
  /** Header */
  header = true,
  headerClassName = "",
  closeButtons = true,
  /** Title */
  title = "",
  titleClassName = "",
  titleAs = "h4",
  /** Body */
  body = true,
  bodyClassName = "",
  children = null,
  /** Footer */
  footer = true,
  footerClassName = "",
  footerChildren = null,
}) {
  const HandleClose = () => {
    onHide();
    onClose();
  };

  return (
    <Modal dialogClassName={`${dialogClassName}`} contentClassName={`${contentClassName}`} size={size} show={show} onHide={HandleClose} fullscreen={fullScreen} centered={centered} backdrop={backdrop}>
      {header && (
        <Modal.Header className={`${headerClassName}`} closeButton={closeButtons}>
          <Modal.Title className={`${titleClassName}`} as={titleAs}>
            {title}
          </Modal.Title>
        </Modal.Header>
      )}
      {body && <Modal.Body className={`${bodyClassName}`}>{children}</Modal.Body>}
      {footer && <Modal.Footer className={`${footerClassName}`}>{footerChildren}</Modal.Footer>}
    </Modal>
  );
}

export default Dialog;
